<template>
  <div class="appBox" id="calApp">
    <!--       <p>{{ display }}:{{ prevOps }}:{{ decimalAdded }}:{{ total }}</br>CurrentNum=> {{ currentNum }}</p> -->
    <v-card class="pa-4 pr-6" elevation="0">
      <div class="row">
        <div class="col-xs-8 cTop ml-3">{{ display }}</div>
      </div>
      <div class="row">
        <div class="col-xs-2"><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="clear">C</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterOps(4)">÷</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterOps(3)">X</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 title font-weight-black " x-large
            @click="del">DEL</v-btn></div>
      </div>
      <div class="row">
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(7)">7</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(8)">8</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(9)">9</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterOps(2)">-</v-btn></div>
      </div>
      <div class="row">
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(4)">4</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(5)">5</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(6)">6</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterOps(1)">+</v-btn></div>
      </div>
      <div class="row">
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(1)">1</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(2)">2</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(3)">3</v-btn></div>
        <div class="col-xs-2 ">&nbsp;</div>
      </div>
      <div class="row">
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="enterNum(0)">0</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="addDecimal">.</v-btn></div>
        <div class="col-xs-2  "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " disabled
            x-large>&nbsp;</v-btn></div>
        <div class="col-xs-2 "><v-btn elevation="0" class="d-inline ml-2 display-1 font-weight-black " x-large
            @click="sum">=</v-btn></div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      currentNum: 0,
      decimalAdded: false,
      total: 0,
      prevOps: 0,
      display: '',
    };
  },
  ready: function () {
    var target, ink, d, x, y
    (".containerBox .row .cBox").click(function (e) {
      target = (this);
      //create .ink element if it doesn't exist
      if (target.find(".ink").length == 0)
        target.prepend("<span class='ink'></span>");

      ink = target.find(".ink");
      //incase of quick double clicks stop the previous animation
      ink.removeClass("animate");

      //set size of .ink
      if (!ink.height() && !ink.width()) {
        //use parent's width or height whichever is larger for the diameter to make a circle which can cover the entire element.
        d = Math.max(target.outerWidth(), target.outerHeight());
        ink.css({
          height: d,
          width: d
        });
      }

      //get click coordinates
      //logic = click coordinates relative to page - parent's position relative to page - half of self height/width to make it controllable from the center;
      x = e.pageX - target.offset().left - ink.width() / 2;
      y = e.pageY - target.offset().top - ink.height() / 2;

      //set the position and add class .animate
      ink.css({
        top: y + 'px',
        left: x + 'px'
      }).addClass("animate");
    })
  },
  methods: {
    addDecimal: function () {
      if (this.decimalAdded == false) {
        if (this.prevOps != 0) {
          this.display = '0.';
        } else {
          this.display += '.';
        }
        this.decimalAdded = true;
      }
    },
    clear: function () {
      this.currentNum = 0;
      this.decimalAdded = false;
      this.total = 0;
      this.display = '';
      this.prevOps = 0;
    },
    del: function () {
      if (this.currentNum > 0) {
        if (this.decimalAdded == false) {
          this.currentNum = parseFloat(this.currentNum.toString().slice(0, -1), 10);
        } else {
          this.currentNum = parseFloat(this.currentNum.toString().slice(0, -1));
        }

        if (isNaN(this.currentNum))
          this.currentNum = 0;
        this.display = this.currentNum;
      } else if (this.currentNum == 0) {
        this.display = '';
      }
    },
    enterNum: function (val) {
      if (this.currentNum == 0) {
        if (this.prevOps == 0)
          this.total = 0;

        if (this.decimalAdded == true) {
          this.currentNum = val / 10;
          this.display += val.toString();
        } else {
          this.currentNum = val;
          this.display = val.toString();
        }
      } else {
        if (this.decimalAdded == true) {
          if (this.currentNum.toString().indexOf('.') == -1) {
            this.currentNum = parseFloat(this.currentNum.toString() + '.' + val.toString());
          } else {
            this.currentNum += val.toString();
            this.currentNum = parseFloat(this.currentNum);
          }
        } else {
          this.currentNum *= 10;
          this.currentNum += val;
        }
        this.display += val.toString();
      }
    },
    enterOps: function (ops) {
      if (this.total == 0 && this.currentNum == 0) {
        return;
      }
      if (this.total == 0) {
        this.total += this.currentNum;
      }
      switch (this.prevOps) {
        case 1:
          this.total += this.currentNum;
          break;
        case 2:
          this.total -= this.currentNum;
          break;
        case 3:
          this.total *= this.currentNum;
          break;
        case 4:
          this.total /= this.currentNum;
          break;
        case 0:
          break;
      }

      if (this.decimalAdded == true) {
        this.decimalAdded = false;
      }
      this.currentNum = 0;
      this.prevOps = ops;
    },
    sum: function () {
      switch (this.prevOps) {
        case 1:
          this.total += this.currentNum;
          break;
        case 2:
          this.total -= this.currentNum;
          break;
        case 3:
          this.total *= this.currentNum;
          break;
        case 4:
          this.total /= this.currentNum;
          break;
        case 0:
          break;
      }
      this.display = this.total.toString();
      this.prevOps = 0;
      this.currentNum = 0;
    }
  }
}
</script>

<style scoped>
.cBox {
  border: 1px solid rgba(95, 95, 95, 0.2);
  cursor: pointer;
  display: inline-block;
  float: none;
  font-size: 20px;
  margin-right: -4px;
  max-width: 8rem;
  min-width: 6rem;
  min-height: 5rem;
  overflow: hidden;
  position: relative;
  padding: 2.5rem;
  text-align: center;
  transition: all 0.4s ease;
}

.cBox:hover {
  background: #75B1A9;
}

.cBox-na:hover {
  background: #ACD0C0 !important;
}

.cTop {
  display: inline-block;
  float: none;
  text-align: right;
  margin-right: -4px;
  max-width: 32rem;
  min-width: 24rem;
  height: 80px;
  font-size: 20px;
  border: 1px solid rgba(95, 95, 95, 0.2);
  padding: 2.5rem;
}


.row-centered {
  text-align: center;
}

.row {
  margin-bottom: -1px;
}

/*.ink styles - the elements which will create the ripple effect. The size and position of these elements will be set by the JS code. Initially these elements will be scaled down to 0% and later animated to large fading circles on user click.*/
.ink {
  display: block;
  position: absolute;
  background: #D9B44A;
  border-radius: 100%;
  transform: scale(0);
}

/*animation effect*/
.ink.animate {
  animation: ripple 0.3s linear;
}

@keyframes ripple {

  /*scale the element to 250% to safely cover the entire link and fade it out*/
  100% {
    opacity: 0;
    transform: scale(2.5);
  }
}</style>